
import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faTrophy, faDumbbell, faUtensils, faCut, faHorse } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from './../../assets/khera.jpg';

const SainikSchoolKhera = () => {
    const facilities = [
        { name: 'Gymnasium', icon: faDumbbell },
        { name: 'Cafeteria', icon: faUtensils },
        { name: 'Barber Services', icon: faCut },
        { name: 'Horse Riding', icon: faHorse }
    ];

    const achievements = [
        { course: 'NDA Course 150', cleared: '10', recommended: '03' },
        { course: 'NDA Course 151', cleared: '10', recommended: '02' },
        { course: 'NDA Course 152', cleared: '12', recommended: '05' }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faSchool} className="me-2" />
                        Sainik School Khara Kheri
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <div className="mb-4">
                    <img 
                        src={img} 
                        alt="Sainik School Khara Kheri" 
                        style={{
                            width: '100%',
                            height: '370px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
                        }}
                    />
                </div>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faSchool} className="me-2" />
                            About the School
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Fatehabad is the land of warriors with indomitable courage who never knelt before enemies on the battlefield. The soldiers of Fatehabad have also made their invincible presence acknowledged in the battles of 1962, 1965, 1971, and 1999. With these values of Patriotism and Sacrifice, a new landmark was achieved in the history of Sainik Schools as well as Fatehabad when the foundation stone of Sainik School Fatehabad was laid down by the then Defence Minister at Gothra Tappa Khori, on 29 August 2008, and in this way, Sainik School Fatehabad emerged as the 24th Sainik School of the nation and the second Sainik School in Haryana.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The Memorandum of Agreement (MOA) for establishing Sainik School Fatehabad was signed between the Ministry of Defence and the State Govt in June 2008, and subsequently, regular classes for the first academic session commenced from 01 May 2009 with 81 ardent cadets.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The motto of the school is 'Gyan Sadbhavna Desh Bhakti' which denotes the three primary qualities that the cadets must imbibe.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The School got its affiliation from CBSE for running secondary classes in the year 2012. The affiliation was upgraded to Senior Secondary level in April 2014.
                            </p>
                        </div>
                        
                        <div className="mb-0">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                There is no sports infrastructure in the School as of now. The School is making makeshift arrangements for cadets in the areas earmarked for residential and non-residential buildings. The sports infrastructure is planned in Phase III & IV for which the Adm Approval is still pending.
                            </p>
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faDumbbell} className="me-2" />
                            Facilities Available in School for Cadets
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="row justify-content-center">
                            {facilities.map((facility, index) => (
                                <div key={index} className="col-md-6 col-lg-3 mb-3">
                                    <div 
                                        className="p-3 text-center rounded"
                                        style={{
                                            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                            color: 'white',
                                            minHeight: '100px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 15px rgba(22,160,133,0.2)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,160,133,0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(22,160,133,0.2)';
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={facility.icon} 
                                            style={{ fontSize: '2rem', marginBottom: '10px' }}
                                        />
                                        <h6 className="mb-0 fw-bold">{facility.name}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faTrophy} className="me-2" />
                            NDA Achievements
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Preparing the cadets for making a career in the Armed Forces as officers has always been the cherished goal of this institution. A total of 10 cadets out of 52 cleared the NDA Written exam and 03 out of them got recommended for SSB (NDA Course 150), a total of 10 cadets out of 52 cleared the NDA Written exam and 02 out of them got recommended for SSB (NDA Course 151), and a total of 12 cadets out of 43 cleared the NDA Written exam and 05 out of them got recommended for SSB (NDA Course 152).
                            </p>
                        </div>
                        
                        <div className="row justify-content-center">
                            {achievements.map((achievement, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-3">
                                    <div 
                                        className="p-3 text-center rounded"
                                        style={{
                                            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                                            color: 'white',
                                            minHeight: '100px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 15px rgba(142,68,173,0.2)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(142,68,173,0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(142,68,173,0.2)';
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={faTrophy} 
                                            style={{ fontSize: '2rem', marginBottom: '10px' }}
                                        />
                                        <h6 className="mb-1 fw-bold">{achievement.course}</h6>
                                        <small>Cleared: {achievement.cleared}</small>
                                        <br />
                                        <small>Recommended: {achievement.recommended}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default SainikSchoolKhera;
